import { FETCH_BOLETO } from '../actions/types';

export default function (state = null, action) {
    switch (action.type) {
        case FETCH_BOLETO:
            return action.payload;
        default:
            return state;
    }
}